function update_content(currentButton, request_method, activeClass, articleSlug) {
  $.ajax({
    url: '/article-category',
    method: request_method,
    data: {
      catagory_name: currentButton.value,
      content_slug: articleSlug
    },
    success: () => {
      if (currentButton.classList.contains(activeClass)) {
        currentButton.classList.remove(activeClass)
        currentButton.dataset.categoryStatus = 'inactive'
      } else {
        currentButton.classList.add(activeClass)
        currentButton.dataset.categoryStatus = 'active'
      }
    },
    error: () => {
      window.location.reload()
    }
  })
}

function manageCategory() {
  if (!document.getElementById('categories')) { return }
  const currentUrlInArray = window.location.pathname.split("/");
  const articleSlug = currentUrlInArray[currentUrlInArray.length-1];
  const activeClass = 'active';

  $('.category-item').on('click', function(e){
    if (e.currentTarget.dataset.categoryStatus == 'active') {
      update_content(e.currentTarget, 'DELETE', activeClass, articleSlug);
    } else if (e.currentTarget.dataset.categoryStatus == 'inactive') {
      update_content(e.currentTarget, 'POST', activeClass, articleSlug);
    }
  })
};

window.onload = manageCategory();
